import { render, staticRenderFns } from "./automation-grid-item.vue?vue&type=template&id=28b5d894&scoped=true"
import script from "./automation-grid-item.vue?vue&type=script&lang=js"
export * from "./automation-grid-item.vue?vue&type=script&lang=js"
import style0 from "./automation-grid-item.vue?vue&type=style&index=0&id=28b5d894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5d894",
  null
  
)

export default component.exports